module.exports = __webpack_public_path__ + "static/media/keyholeMessageDoorUnlocked.5e33b1d8.png";